import { render, staticRenderFns } from "./CitizenStatementList.vue?vue&type=template&id=47deaeda&"
import script from "./CitizenStatementList.vue?vue&type=script&lang=js&"
export * from "./CitizenStatementList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports